module.exports = __webpack_public_path__ + "img/csv.1ee1f9c1.png";